// Import necessary functions and modules

import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";


// Create department API using createApi function
const productSalesAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'productSalesAPI',
    endpoints: (builder) => ({

        // Query to get all departments
        getAllInvoiceNumber: builder.query({
            query: (data) => ({
                url: `/ProductSales/GetAllInvoiceNumber?plProductSaleKey=${data.plProductSaleKey}&plDepartmentKey=${data.plDepartmentKey}&pbIncludeCanceled=${data.pbIncludeCanceled}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSalesRep: builder.query({
            query: (data) => ({
                url: `/ProductSales/GetSalesRep?plSalesRepKey=${data.plSalesRepKey}&pbIncludeBlank=${data.pbIncludeBlank}&pbIncludeAll=${data.pbIncludeAll}&psActiveFlag=${data.psActiveFlag}&plCompanyKey=${data.plCompanyKey}&plSalesRepKeyToInclude=${data.plSalesRepKeyToInclude}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllInventoryPrice: builder.query({
            query: (data) => ({
                url: `/ProductSales/GetAllInventoryPrice?plInventoryPricingListKey=${data.plInventoryPricingListKey}&pbIncludeBlank=${data.pbIncludeBlank}&pbIncludeInactive=${data.pbIncludeInactive}&plInventoryPricingListKeyToInclude=${data.plInventoryPricingListKeyToInclude}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addProductSales: builder.mutation({
            query: (data) => ({
                url: `/ProductSales/AddProductSales`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        productSalesSearch: builder.query({
            query: (data) => ({
                url: `/ProductSales/ProductSalesSearch?psInvoiceNumber=${data.psInvoiceNumber}&psPONumber=${data.psPONumber}&psDescription2=${data.psDescription2}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

// Export various hooks and the department API
export const {

    useLazyGetAllInvoiceNumberQuery,
    useLazyGetSalesRepQuery,
    useLazyGetAllInventoryPriceQuery,
    useAddProductSalesMutation,
    useLazyProductSalesSearchQuery

} = productSalesAPI;

export default productSalesAPI;
